import React            from 'react';
import {render}         from 'react-dom';
import {VXPay}          from '../utils/VXPay';
import NavbarSearchIcon from "../components/NavbarSpecialElements/NavbarSearchIcon";

function run(containerId) {
	const container = document.getElementById(containerId);
	if (container) {
		render(<NavbarSearchIcon />, container);
	}
	const navbarLogins  = document.querySelectorAll('.js-navbar-login');
	const navbarSignups = document.querySelectorAll('.js-navbar-signup');
	const navbarLogouts = document.querySelectorAll('.js-navbar-logout');

	navbarLogins && navbarLogins.forEach(function(navbarLogin) {
		navbarLogin.addEventListener('click', function() {
			VXPay.openLogin();
		});
	});
	navbarSignups && navbarSignups.forEach(function(navbarSignup) {
		navbarSignup.addEventListener('click', function() {
			VXPay.openSignup();
		});
	});
	navbarLogouts && navbarLogouts.forEach(function(navbarLogout) {
		navbarLogout.addEventListener('click', function() {
			VXPay.logout();
		});
	});
}

export {run};
